module.exports = require("./lb.d.ts");